(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/cookies-info/views/adjust-cookies.js') >= 0) return;  svs.modules.push('/components/components/cookies-info/views/adjust-cookies.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.cookies_info=_cmps.cookies_info||{};
_cmps.cookies_info.templates=_cmps.cookies_info.templates||{};
svs.components.cookies_info.templates.adjust_cookies = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p>\n    Gör dina val avseende cookies och hur de används nedan:\n</p>";
},"useData":true});
Handlebars.partials['components-components-cookies_info-adjust_cookies'] = svs.components.cookies_info.templates.adjust_cookies;
})(svs, Handlebars);

 })(window);